import { ref, provide, inject, reactive } from 'vue';
// https://penueling.com/%E6%8A%80%E8%A1%93%E7%AD%86%E8%A8%98/vue3-%E7%9A%84%E8%B3%87%E6%96%99%E7%8B%80%E6%85%8B%E7%AE%A1%E7%90%86%EF%BC%8Cprovide-inject%E3%80%81vuex/

// eslint-disable-next-line arrow-body-style
const createI18n = (config) => ({
  locale: ref(config.locale),
  globalInjection: true,
  legacy: false,
  // locale: window.Locale,
  messages: reactive(config.messages),
  $t(key) {
    return this.messages[this.locale.value][key];
  },
});

// eslint-disable-next-line symbol-description
const i18nSymbol = Symbol();
// https://www.cnblogs.com/vickylinj/p/13037892.html

export function provideI18n(i18nConfig) {
  const i18n = createI18n(i18nConfig);
  provide(i18nSymbol, i18n);
}

export function useI18n() {
  const i18n = inject(i18nSymbol);
  if (!i18n) throw new Error('No i18n provided!!!');
  window.$i18n = i18n;
  return i18n;
}

export function checki18n(i18n, propsText) {
  if (!propsText) {
    return '';
  }
  //
  let str = '';
  if (typeof propsText === 'string') {
    if (propsText.includes(',') && !propsText.includes(';')) {
      const split = propsText.split(', ');
      split.forEach((item) => {
        if (i18n.$t(item) !== undefined) {
          str += i18n.$t(item);
        }
      });
      //
      if (str === '') {
        str = propsText;
      }
      //
    } else {
      str = i18n.$t(propsText);
      if (str === undefined) {
        str = propsText;
      }
    }
  }
  return str;
}

/**
 * 替換語系文字
 * @param {*} obj
 * @param {*} path
 * @param {*} value
 */
export function replaceLangugeTextDeep(obj, path, value) {
  // console.log('replaceLangugeTextDeep obj', obj);
  // console.log('replaceLangugeTextDeep path', path);
  // console.log('replaceLangugeTextDeep value', value);

  const parts = path.split('.');

  let current = obj;

  // 如果第一層是語系名，先去掉
  if (parts[0] === 'zhtw') parts.shift();
  for (let index = 0; index < parts.length - 1; index += 1) {
    if (!current[parts[index]]) {
      // 如果不存在就創建
      current[parts[index]] = {};
    }
    current = current[parts[index]];
  }
  current[parts[parts.length - 1]] = value;
}
